<template>
  <subscription-info-form
    :id="id"
    :section.sync="section"
    :subscription-no="subscriptionNo"
    :is-auto-calc-shipping.sync="isAutoCalcShipping"
    :is-show-popup.sync="isShowPopup"
    @confirm="toConfirmPage"
  />
</template>

<script>
import SubscriptionInfoForm from '@/components/ec-line015/SubscriptionInfoForm.vue'
import { getFee } from '@/router/func'

export default {
  props: {
    id: { type: String, default: () => null },
  },
  components: {
    SubscriptionInfoForm,
  },
  data() {
    return {
      section: '',
      subscriptionNo: '',
      isAutoCalcShipping: false,
      isShowPopup: true,
    }
  },
  created() {
    const { section, subscriptionNo, isAddProduct } = this.$route.query
    this.section = section
    this.isAutoCalcShipping = /^true$/i.test(isAddProduct)
    this.subscriptionNo = subscriptionNo || this.$store.getters['subscription/getSubscriptionNo']
    getFee()
  },
  methods: {
    toConfirmPage() {
      this.$router.replace({ name: 'EC_LINE028', params: { id: this.id } })
    },
  },
  metaInfo() {
    return {
      title: this.$t('ec-line015.title'),
      script: [
        {
          src: process.env.VUE_APP_GMO_LIB_URL,
        },
      ],
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.$t('ec-line015.description', { shop_name: this.shopName }),
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.$t('ec-line015.keyword', { shop_name: this.shopName }),
        },
      ],
    }
  },
}
</script>
